import { useSearchParams } from 'react-router-dom';

export const useParam = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const getUrlParam = (paramName) => {
        const value = searchParams.get(paramName);
        if (value !== null) {
            searchParams.delete(paramName);
            setSearchParams(searchParams, { replace: true }); // заменяем URL без перезагрузки
        }
        return value;
    };

    const removeQueryParam = (paramName) => {
        searchParams.delete(paramName);
        setSearchParams(searchParams, { replace: true });
    };

    return { getUrlParam, removeQueryParam };
};
